// extracted by mini-css-extract-plugin
export default {"agentReviewsEmptyListForTheYear":"agentReviewsEmptyListForTheYear_Wy6BM","title":"title_OIdZN","description":"description_SleFO","buttonContainer":"buttonContainer_ic7MP"};